<template>
  <div id="global-header">
    <nav class="nav-menu">
      <img
        style="width: 310px; height: 40px; align-self: center"
        src="../assets/repponlogog6.png"
        alt="logo"
      />
      <ul>
        <li v-for="(item, index) in titlesArrray" :key="index">
          <a v-if="item.wlink" :href="item.href" target="_blank">{{
            item.title
          }}</a>
          <router-link
            v-else
            :style="
              activeKey === index ? { color: 'color: rgb(0 106 233)' } : {}
            "
            :to="item.path"
            @click="selectTitle(item.titleText, index)"
            >{{ item.title }}</router-link
          >
        </li>
      </ul>
    </nav>
  </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
const titlesArrray = ref([
  {
    title: "首页",
    path: "/",
    titleText: "首页-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "服务介绍",
    path: "/services",
    titleText: "服务介绍-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "关于我们",
    path: "/about",
    titleText: "关于我们-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "联系我们",
    path: "/contact",
    titleText: "联系我们-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "客户登录",
    path: "",
    titleText: "",
    // href: "https://ff.jxt56.com/?ff_port_from=555BF0E21CFA01421E66ED7B6E29C902#/base/login/redirect=%2Fbase%2Flogin%",
    href: "https://tat.reppon.com/#/login?id=57",
    wlink: true,
  },
  {
    title: "员工登录",
    path: "",
    titleText: "",
    href: "https://tms.reppon.com/",
    wlink: true,
  },
]);
const activeKey = ref(0);
function selectTitle(titile, index) {
  activeKey.value = index;
  document.querySelector("title").textContent = titile;
}
selectTitle("首页-礼邦物流官网", 0);
</script>
<style scoped>
#global-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-container {
  display: flex;
  text-align: center;
  justify-content: center;
}

.nav-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-menu ul {
  list-style-type: none; /* 去除列表项前端的黑点 */
  display: flex;
  gap: 20px;
  padding: 0;
  margin: 0;
}

.nav-menu li a {
  margin-left: 100px;
  text-decoration: none;
  color: black; /* 更改字体颜色为黑色 */
  font-size: 16px;
  position: relative; /* 使伪元素定位生效 */
  padding-bottom: 4px; /* 为底部条纹预留空间 */
}

.nav-menu li a::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: blue;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.nav-menu li a:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
</style>
